<div class="bn-tooltip-host">
  <span
    #trigger
    class="bn-tooltip-trigger"
    (pointerenter)="$event.pointerType === 'mouse' && show()"
    (pointerleave)="$event.pointerType === 'mouse' && hide()"
    (click)="$event.stopPropagation(); toggle()"
    aria-describedby="bn-tooltip-bubble"
    tabindex="0"
  >
    <ng-container *ngIf="isAcmic; else maTooltipIcon">
      <img src="assets/img/images/icon-info-acmic.svg" class="img-body-tooltip-icon"/>
    </ng-container>
    <ng-template #maTooltipIcon>        
      <img src="assets/img/images/icon-info.svg" class="img-body-tooltip-icon"/>
    </ng-template>
  </span>

  <div
    *ngIf="visible"
    #bubble
    id="bn-tooltip-bubble"
    class="bn-tooltip-bubble"
    [ngClass]="'bn-tooltip-' + position"
    role="tooltip"
    [style.left]="bubbleLeft"
  >
    <svg
      *ngIf="position === 'bottom'"
      class="bn-tooltip-arrow bn-arrow-top"
      [style.left]="arrowLeft"
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="16"
      viewBox="0 0 23 16"
      fill="none"
    >
      <path
        d="M9.90848 14.9088C10.7089 15.9605 12.2911 15.9605 13.0915 14.9088L21.6135 3.71123C22.6155 2.39458 21.6765 0.5 20.0219 0.5H2.97806C1.32348 0.5 0.384508 2.39458 1.38655 3.71123L9.90848 14.9088Z"
        fill="#2D373D"
      />
    </svg>
    <span class="bn-tooltip-content">{{ content }}</span>
    <svg
      *ngIf="position === 'top'"
      class="bn-tooltip-arrow bn-arrow-bottom"
      [style.left]="arrowLeft"
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="16"
      viewBox="0 0 23 16"
      fill="none"
    >
      <path d="M9.90848 14.9088C10.7089 15.9605 12.2911 15.9605 13.0915 14.9088L21.6135 3.71123C22.6155 2.39458 21.6765 0.5 20.0219 0.5H2.97806C1.32348 0.5 0.384508 2.39458 1.38655 3.71123L9.90848 14.9088Z" fill="#2D373D"/>
    </svg>
  </div>
</div>
